__turbopack_context__.v({
  "NewsCardList--Row": "_2ZqM5W_NewsCardList--Row",
  "NewsCardList__Container": "_2ZqM5W_NewsCardList__Container",
  "NewsCardList__Item": "_2ZqM5W_NewsCardList__Item",
  "NewsCardList__Item--1": "_2ZqM5W_NewsCardList__Item--1",
  "NewsCardList__Item--2": "_2ZqM5W_NewsCardList__Item--2",
  "NewsCardList__Item--3": "_2ZqM5W_NewsCardList__Item--3",
  "NewsCardList__Item--Row": "_2ZqM5W_NewsCardList__Item--Row",
  "NewsCardList__List": "_2ZqM5W_NewsCardList__List",
  "NewsCardList__Title": "_2ZqM5W_NewsCardList__Title",
  "NewsCardList__TitleWrapper": "_2ZqM5W_NewsCardList__TitleWrapper",
});
